import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogCancelComponent } from '../dialog-cancel/dialog-cancel.component';
import { Router } from '@angular/router';

@Component({
  selector: 'cigna-page-step-navigation',
  templateUrl: './page-step-navigation.component.html',
  styleUrls: ['./page-step-navigation.component.scss'],
})
export class PageStepNavigationComponent {
  @Input() previousButtonLabel = 'Previous';
  @Input() nextButtonLabel = 'Next';
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showPrevious = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() nextEnabled = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() showCancel = true;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input() submitting = false;

  @Output() previous = new EventEmitter();
  @Output() next = new EventEmitter();

  constructor(public dialog: MatDialog, private router: Router) {}

  cancel(): void {
    const dialogRef = this.dialog.open(DialogCancelComponent, {
      width: '700px',
      disableClose: true,
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {});

    dialogRef.componentInstance.cancelConfirm.subscribe(() => {
      dialogRef.close();
      this.router.navigateByUrl('my-practice/manage-access');
    });
  }
}
